export default "__VITE_ASSET__DQuR705H__"